<template>
    <div>
        <div class="panel-group">
            <div class="panel panel-default" v-if="profile !== null">
                <div class="panel-heading">
                    <h4 class="panel-title">
                        <a data-toggle="collapse" data-parent="#accordion" href="#">
                            Profile <span class="label label-info">{{ profile.displayName }}</span>
                        </a>
                    </h4>
                </div>
                <div style="text-align:right;">
                    <span class="btn btn-primary" @click="logout">Logout</span>
                </div>

                <div class="panel-collapse collapse in">
                    <div class="panel-body">
                        <div style="max-width:320px;margin:0 auto;padding:4px;">
                            <div class="row">
                                <div class="col-xs-4" style="text-align:right;">Email:</div>
                                <div class="col-xs-8">{{ profile.email }}</div>
                            </div>
                            <div class="row">
                                <div class="col-xs-4" style="text-align:right;">Phone:</div>
                                <div class="col-xs-8">{{ profile.phone }}</div>
                            </div>
                            <div class="row">
                                <div class="col-xs-4" style="text-align:right;">Gender:</div>
                                <div class="col-xs-8">{{ profile.gender }}</div>
                            </div>
                            <div class="row">
                                <div class="col-xs-4" style="text-align:right;">Join Date:</div>
                                <div class="col-xs-8">{{ profile.createDate }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" style="text-align:center;margin:4px;">
                    <div class="col-xs-4">
                        <router-link to="/" class="form-control">Home</router-link>
                    </div>
                    <div class="col-xs-4">
                        <router-link to="/cart" class="form-control">Cart</router-link>
                    </div>
                    <div class="col-xs-4">
                        <router-link to="/orders" class="form-control">Orders</router-link>
                    </div>
                </div>

                <div class="row" style="text-align:center;margin:4px;">
                    <div class="col-xs-4"></div>
                    <div class="col-xs-4"></div>
                    <div class="col-xs-4">
                        <span class="form-control" @click="inView = 'qa'">Show QA</span>
                    </div>
                </div>

                <paged-qa v-if="inView === 'qa'" @onenquire="enquire" :api-client="apiClient.qaApiClient" page-path=""
                    page-query="" to-user-id=""></paged-qa>

                <modal-x :show="showItem" @onclose="showItem = false">
                    <item-detail v-if="showItem" :api-client="itemApiClient" :post-id="postId"></item-detail>
                </modal-x>

                <div class="row" style="text-align:left;margin:4px;">
                    <div class="col-xs-12">
                        <span class="btn btn-warning" @click="isDeleting = true">Delete Account</span>
                        <div v-if="isDeleting" class="row" style="border:1px solid red;margin:4px;">
                            <div class="col-xs-12" style="text-align:center;">Please Enter your password to confirm delete.
                                This is not recoverable action, please be careful. </div>
                            <div class="col-xs-4" style="text-align:right;">Password</div>
                            <div class="col-xs-8"><input type="password" v-model="password" /></div>
                            <div class="col-xs-12">
                                <span style="color:red;">{{ deleteMsg }}</span>
                            </div>
                            <div class="col-xs-12" style="text-align:right;padding:10px;"><input type="button"
                                    class="btn btn-danger" value="Confirm Delete" @click="deleteAccount" /></div>
                        </div>
                    </div>
                </div>

            </div>
            <div v-else>
                <div style="text-align: center;">
                    <span @click="mxnAgxShowLogin(true)" class="btn btn-default">Please Login First</span>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import modalX from './base/ModalX.vue';
import pagedQA from './PagedQA.vue';
import itemDetail from './ItemDetail.vue';

export default {
    components: {
        modalX: modalX,
        pagedQa: pagedQA,
        itemDetail: itemDetail
    },
    methods: {
        enquire: function (item) {
            console.log('item enquiry', item);
            if (item.path === 'itemdetail') {
                this.postId = item.query;
                this.showItem = true;
            }
        },
        deleteAccount: function () {
            var info = { id: this.profile.email, password: this.password };
            this.apiClient.deleteAccountPrms(info).then((ret) => {
                console.log(ret);
                if (ret === true) {
                    this.deleteMsg = "Delete Sucess!";
                } else {
                    this.deleteMsg = "Delete Fail, Please check your password!";
                }
            });
        },
        logout: function () {
            this.apiClient.logoutPrms();
        },
        loadProfile: function () {
            this.apiClient.getProfilePrms().done((data) => {
                this.profile = data.value;
            });
        },
        reloadItems: function () {
            this.loadProfile();
        }
    },
    data: function () {
        return {
            inView: null,
            showItem: false,
            postId: null,
            isDeleting: false,
            password: null,
            deleteMsg: null
        }
    },
    computed: {
        apiClient: function () {
            return this.mxnAgxApi.accountApiClient;
        },
        profile: function () {
            return this.$store.getters.account;
        },
    },
    mounted: function () {
    },
    created: function () {
        this.apiClient.onLoginApi.on(this.reloadItems);
    },
    destroyed: function () {
        this.apiClient.onLoginApi.remove(this.reloadItems);
    }
}
</script>